import React, { useContext } from "react";
import {useSelector} from 'react-redux';
import {Routes, Route, Outlet } from 'react-router-dom'
import ProtectedRoute from "../services/ProtectedRoute";
import AuthenticationRouteGuard from "../services/AuthenticationRouteGuard";
import "./index.css";
import "./chart.css";
import "./step.css";
import Nav from "./layouts/nav";
import ScrollToTop from "./layouts/ScrollToTop";
import Registration from "./pages/Registration";
import Login from "./pages/Login";
import LockScreen from "./pages/LockScreen";
import Error400 from "./pages/Error400";
import Error403 from "./pages/Error403";
import Error404 from "./pages/Error404";
import Error500 from "./pages/Error500";
import Error503 from "./pages/Error503";
import ManageServices from "./components/Barber/BarberShop/ManageServices"
import ManageStaff from "./components/Barber/BarberShop/MangeStaff"
import Settings from "./components/Barber/Profile/Settings/Settings"
import Overview from "./components/Barber/Overview/Overview"
import Calendar from "./components/Barber/Calendar/Calendar"
import Search from "./components/Barber/Search/Search"
import MakeBooking from "./components/Barber/MakeBooking/MakeBooking"
import MiniSite from "./components/Barber/MiniSite/MiniSite"
import CancelAppointment from "./components/Barber/CancelAppointment/CancelAppointment";
import Support from "./components/Barber/Support/Support";
import LandingPage from "./components/Barber/HomePage/LandingPage"
import RequestForgotPassword from "./components/Barber/ForgotPassword/RequestForgotPassword";
import ResetPassword from "./components/Barber/ForgotPassword/ResetPassword";
import { ThemeContext } from "../context/ThemeContext";
import SiteLoader from "./components/ClientSite/SiteLoader";
import OnlineBooking from "./components/Barber/OnlineBooking/OnlineBooking";
import Roster from "./components/Barber/Roster/Roster";
const Markup = () => {  

  const allroutes = [
    { url:"manage-services", component: <ManageServices /> },
    { url:"manage-staff", component: <ManageStaff /> },
    { url:"", component: <Overview /> },
    { url:"calendar", component: <Calendar /> },
    { url:"search", component: <Search /> },
    { url:"mini-site", component: <MiniSite /> },
    // { url:"client-site", component: <ClientSite /> },
    { url:"settings", component: <Settings /> },
    { url:"support", component: <Support /> },
    { url:"online-booking", component: <OnlineBooking /> },
    { url:"roster", component: <Roster /> },
  ];

  return (    
    <>
      <Routes >
        <Route path='make-a-booking' element= {
<MakeBooking />
} />

        <Route path='client-site' element= {
<SiteLoader />
} />




<Route path='request-forgot-password' element= {
<RequestForgotPassword />
} />

<Route path='reset-password' element= {
<ResetPassword />
} />

<Route path='cancel-appointment' element= {
<CancelAppointment />
} />

{/* <Route path='support' element= {
<Support />
} /> */}

<Route path='landing-page' element= {
<LandingPage />

} />


        <Route exact path='page-register' element= {
          <AuthenticationRouteGuard>
            <Registration />
          </AuthenticationRouteGuard>
        } />

        <Route path='login' element= {
          <AuthenticationRouteGuard>
            <Login />
          </AuthenticationRouteGuard>
        } />

      </Routes>
    <ProtectedRoute>
        <Routes >
          {/* <Route path='page-login' element= {<Login />} />
          <Route path='page-register' element= {<Registration />} /> */}
          <Route path='page-lock-screen' element= {<LockScreen />} />
          <Route path='page-error-400' element={<Error400/>} />
          <Route path='page-error-403' element={<Error403/>} />
          <Route path='page-error-404' element={<Error404/>} />
          <Route path='page-error-500' element={<Error500/>} />
          <Route path='page-error-503' element={<Error503/>} />
          <Route  element={<MainLayout />} >
              {allroutes.map((data, i) => (
                <Route
                  key={i}
                  exact
                  path={`${data.url}`}
                  element={
                    data.component
                    }
                />
              ))}
          </Route>
        </Routes>

        </ProtectedRoute>

        <ScrollToTop /> 
    </>
  );
};


function MainLayout(){
  const {sidebariconHover} = useContext(ThemeContext);
  const sideMenu = useSelector(state => state.sideMenu);
  return (
    <>      
        <div id="main-wrapper" 
          className={`show ${sidebariconHover ? "iconhover-toggle": ""} ${ !sideMenu ? "menu-toggle" : ""}`}          
        >  
          <Nav />
          <div className="content-body" style={{ minHeight: window.screen.height - 60 }}>
              <div className="container-fluid">
                <Outlet />                
              </div>
          </div>
          {/* <Footer /> */}
        </div>
      
    </>
  )

};

export default Markup;